export enum WorkflowType {
    BorrowerApplication = 1,
    LenderApplication = 2,
    BrokerBorrowerApplication = 3,
    BrokerLenderApplication = 4,
    BorrowerSettlement = 5,
    PartnerIntegration = 6
}
